/* Toggles .is-visible on any .kion-reveal element once it scrolls into
   view. One shared observer for every Kion section that uses the reveal
   utility in kion.css. Elements are unobserved after their first reveal —
   this never re-hides on scroll back up. Safe to load before or after the
   elements it targets exist in the DOM. */
(function () {
  function init() {
    if (window.kionRevealObserver) {
      document.querySelectorAll('.kion-reveal').forEach(function (el) {
        window.kionRevealObserver.observe(el);
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.kion-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    window.kionRevealObserver = observer;

    document.querySelectorAll('.kion-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

